/* PolicyDetailsSubviewComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./PolicyDetailsSubviewRenderer");

class PolicyDetailsSubviewComponent extends EventEmitter {
    constructor(logger, gameEditor, state, io) {
        super();

        this._io = io;
        this._logger = logger;
        this._gameEditor = gameEditor;

        this._auditPolicy = _.get(state, "configExecutionEntity.auditPolicy", undefined);

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    whenModelIsReady() {
        return Promise.all([this.gameEditor.whenPolicyIsReady(), this.gameEditor.whenConceptItemsAreReady()]).then(() => {
            return Promise.resolve();
        });
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get io() {
        return this._io;
    }
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }

    get auditPolicy() {
        return this._auditPolicy;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._auditPolicy = undefined;
        this._renderer = undefined;
        this._logger = undefined;
        this._gameEditor = undefined;
        return Promise.resolve(prom).then(() => {});
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = PolicyDetailsSubviewComponent;
PolicyDetailsSubviewComponent.$inject = ["$teve.logger", "gameEditor.gameEditor", "gameEditor.viewState", "$teve.io"];
PolicyDetailsSubviewComponent.$displayDetails = {
    type: "View",
    name: "Policy Details",
    icon: "common.edit",
    shown: false
};
